/* OpenQwenChat — icon set (stroke icons, 1.7 weight) */
import React from 'react';

const Ic = {};
const mk = (paths, vb = "0 0 24 24") => ({ size = 20, ...p } = {}) =>
  React.createElement("svg", { width: size, height: size, viewBox: vb, fill: "none",
    stroke: "currentColor", strokeWidth: 1.7, strokeLinecap: "round", strokeLinejoin: "round", ...p },
    paths.map((d, i) => React.createElement("path", { key: i, d })));

Ic.Plus       = mk(["M12 5v14", "M5 12h14"]);
Ic.Search     = mk(["M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", "m21 21-4.3-4.3"]);
Ic.Community  = mk(["M4 4h7v7H4z", "M13 4h7v7h-7z", "M4 13h7v7H4z", "M13 13h7v7h-7z"]);
Ic.Coder      = mk(["m9 8-4 4 4 4", "m15 8 4 4-4 4"]);
Ic.FolderPlus = mk(["M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", "M12 11v5", "M9.5 13.5h5"]);
Ic.Panel      = mk(["M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z", "M9 5v14"]);
Ic.Chev       = mk(["m6 9 6 6 6-6"]);
Ic.ChevUp     = mk(["m6 15 6-6 6 6"]);
Ic.Mic        = mk(["M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", "M5 11a7 7 0 0 0 14 0", "M12 18v3"]);
Ic.MicOff     = mk(["M9 5a3 3 0 0 1 6 0v4", "M15 11.5V11", "M5 11a7 7 0 0 0 10.5 6", "M12 18v3", "M3 3l18 18"]);
Ic.Waveform   = mk(["M4 10v4", "M8 6v12", "M12 3v18", "M16 6v12", "M20 10v4"]);
Ic.Close      = mk(["M6 6l12 12", "M18 6 6 18"]);
Ic.Sliders    = mk(["M4 8h10", "M18 8h2", "M4 16h2", "M10 16h10", "M14 6v4", "M6 14v4"]);
Ic.Copy       = mk(["M9 9h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1Z", "M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"]);
Ic.Check      = mk(["m5 13 4 4L19 7"]);
Ic.Refresh    = mk(["M21 12a9 9 0 1 1-3-6.7", "M21 4v5h-5"]);
Ic.ThumbUp    = mk(["M7 11v9H4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1z", "M7 11l4-7a2 2 0 0 1 2.7 2.6L12.5 9H19a2 2 0 0 1 2 2.3l-1.2 6A2 2 0 0 1 17.8 19H7"]);
Ic.Pencil     = mk(["M4 20h4L19 9a2 2 0 0 0-3-3L5 17z", "M14 6l3 3"]);
Ic.Pin        = mk(["M9 4h6l-1 6 3 3v2H7v-2l3-3z", "M12 15v5"]);
Ic.Image      = mk(["M3 5h18v14H3z", "M3 16l5-5 4 4 3-3 6 6", "M8.5 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"]);
Ic.Globe      = mk(["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", "M3 12h18", "M12 3a14 14 0 0 1 0 18", "M12 3a14 14 0 0 0 0 18"]);
Ic.Sparkle    = mk(["M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"]);
Ic.Sun        = mk(["M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z", "M12 1v2", "M12 21v2", "M4.2 4.2l1.4 1.4", "M18.4 18.4l1.4 1.4", "M1 12h2", "M21 12h2", "M4.2 19.8l1.4-1.4", "M18.4 5.6l1.4-1.4"]);
Ic.Moon       = mk(["M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"]);
Ic.Stop       = mk(["M7 7h10v10H7z"]);
Ic.Dots       = ({ size = 20, ...p } = {}) =>
  React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "currentColor", stroke: "none", ...p },
    [6, 12, 18].map(cx => React.createElement("circle", { key: cx, cx, cy: 12, r: 1.6 })));
Ic.Bot        = mk(["M12 3v3", "M6 8h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z", "M9 13v1.5", "M15 13v1.5", "M2 12v3", "M22 12v3"]);

export { Ic };
